var map = {
	"./01.png": 850,
	"./02.png": 3785,
	"./03.png": 7536,
	"./04.png": 6559,
	"./05.png": 1366,
	"./06.png": 2573,
	"./07.png": 1444,
	"./08.png": 7363,
	"./09.png": 1802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9209;